import { useContext, useState } from 'react'

import { TogetherTypes } from '@hhgtech/hhg-components'
import { Button, ButtonProps } from '@hhgtech/hhg-components/mantine'
import { Box } from '@mantine/core'
import { useIntl } from 'react-intl'

import { getHelloSitesUrl } from 'api/utils/paths'
import { redirectToSSOWithReturnUrl } from 'api/utils/redirects'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { AppContext } from 'state/appContext'

type Props = {
  community: TogetherTypes.Community
  isFollowing: boolean
  onJoinCommunity?: () => void
  joinCommunity?: (id: number | string) => Promise<any>
  joinedLabel?: string
  goToLabel?: string
} & ButtonProps

export const CommunityBtn = ({
  community,
  isFollowing,
  joinCommunity,
  joinedLabel,
  goToLabel,
  onJoinCommunity,
  ...btnProps
}: Props) => {
  const { formatMessage: f } = useIntl()
  const {
    state: { isLoggedIn },
  } = useContext(AppContext)
  const { locale } = useRouterExtend()
  const [isLoading, setIsLoading] = useState(false)

  return (
    <Box
      component={isFollowing ? 'a' : 'div'}
      href={`/community/${community?.slug}/`}
    >
      <Button
        loading={isLoading}
        fullWidth
        data-event-category="Together Embedded"
        data-event-action={isFollowing ? 'Go to Community' : 'Join Community'}
        data-event-label={community.name}
        {...btnProps}
        onClick={(e) => {
          if (!isFollowing) {
            e.preventDefault()
            if (isLoggedIn && community?.id) {
              setIsLoading(true)
              joinCommunity?.(community.id).then((response) => {
                if (response?.status === 1) {
                  onJoinCommunity?.()
                }
                setIsLoading(false)
              })
            } else {
              redirectToSSOWithReturnUrl(
                `${getHelloSitesUrl(
                  locale,
                )}/community/on-boarding/?returnUrl=/${community?.slug}`,
              )
            }
          }
        }}
      >
        {isFollowing
          ? goToLabel ||
            f({
              id: 'cardCommunity.goToCommunity',
            })
          : joinedLabel ||
            f({
              id: 'cardCommunity.joinCommunity',
            })}
      </Button>
    </Box>
  )
}
